export const listItems = {
    brandMobile: {
        title: "AG",
        classes: "m-auto custom-logo-collapse",
        brand: true,
        path: "/",
        exact: false,
        img: './assets/images/logo/small/dark.png'
    },
    items: [
        {
            title: "AG",
            classes: "ml-2 mr-4 custom-logo",
            brand: true,
            path: "/",
            exact: false,
            img: './assets/images/logo/medium/dark.png'
        },
        {
            title: "Inicio",
            classes: "mx-2 custom-border-bottom-navbar-item",
            brand: false,
            path: "/",
            exact: true
        },
        {
            title: "Trabajos",
            classes: "mx-2 custom-border-bottom-navbar-item",
            brand: false,
            path: "/trabajos",
            exact: false
        },
        {
            title: "Sobre Mí",
            classes: "mx-2 custom-border-bottom-navbar-item",
            brand: false,
            path: "/sobremi",
            exact: false
        },
        {
            title: "Contacto",
            classes: "mx-2",
            brand: false,
            path: "/contacto",
            exact: true
        }
    ]
};